import React from 'react';
import Img from './Img';
import MarketInfoModal from './MarketInfoModal';
import { openModal } from './ModalContainer';
import { getToolTipDesc } from '../data/utils';

export default function MarketInfo(props) {
    function handleClick(e) {
        e.stopPropagation();
        
        let position = null;
        try {
            const rect = e.currentTarget.closest('.c_21').getBoundingClientRect();
            position = {
                top: `${rect.top}px`,
                left: `${rect.left}px`,
                width: rect.width
            };
        } catch(e) {}

        openModal(
            <MarketInfoModal desc={props.desc} style={position}>
                {props.odds.map((o, i) =>
                    <div key={i} className="c_55_3_1">
                        <span className="c_55_3_1_1">{o.desc}</span>
                        <span className="c_55_3_1_2"> - </span>
                        <span className="c_55_3_1_2">{getToolTipDesc(o)}</span>
                    </div>
                )}
            </MarketInfoModal>
        );
    }

    return (
        <div className="c_23" onClick={handleClick}>
            <Img className="c_23_1" src="icon_info.svg" height="24px" width="24px" />
        </div>
    );
}
